/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import { Component, Prop, Vue } from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import SteamAuth from '@/mixins/SteamAuth';

/**
 * Steam login component.
 *
 * This is a steam login component that redirects a user to the steam login page.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'c-steam-login',
})
export default class SteamLogin extends mixins(SteamAuth) {
}

